<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      Утвержден Приказом Председателя<br />
      Агентства Республики Казахстан<br />
      по делам строительства и<br />
      жилищно-коммунального хозяйства<br />
      от 29 декабря 2011 года № 536<br />
      <br />
      Сборник нормативно-технической<br />
      и исполнительной документации,<br />
      необходимой при проведении<br />
      строительно-монтажных работ<br />
      (паспорт строительства)<br />
      <br />
      Приложение 20
    </div>
    <div class="chapter-title">Журнал бурения скважин, разбуривания уширений в основании скважин или оболочек</div>
    <n-items v-if="project">
      <n-input title="Строительная организация" v-bind="$form.input('executor')" :text="!editable" />
      <n-input title="Строительство" v-bind="$form.input('building')" :text="!editable" />
      <n-input title="Опора №" v-bind="$form.input('supportNumber')" :text="!editable" />
      <n-input title="№ скважин или оболочек по проектному плану" v-bind="$form.input('wellsNumbers')" :text="!editable" />
      <n-input title="Фундамента" v-bind="$form.input('fundament')" :text="!editable" />
      <n-input title="тип бурового механизма" v-bind="$form.input('drillType')" :text="!editable" />
      <n-input title="рабочий орган" v-bind="$form.input('workOrgan')" :text="!editable" />
      <n-input title="Начат" v-bind="$form.input('beginAt')" :text="!editable" />
      <n-input title="Окончен" v-bind="$form.input('finishAt')" :text="!editable" />
      <n-input title="Начальник производственного отдела" v-bind="$form.input('productionMaster')" :text="!editable" />
      <n-input title="Оболочка или скважина №" v-bind="$form.input('wellNumber')" :text="!editable" />
      <n-input title="Отметка поверхности грунта, м" v-bind="$form.input('markEarthTop')" :text="!editable" />
      <div style="width: 100%">Оболочка</div>
      <n-input title="наружный диаметр, м" v-bind="$form.input('outerDiameter')" :text="!editable" />
      <n-input title="толщина стенки, см" v-bind="$form.input('wallThickness')" :text="!editable" />
      <n-input title="отметка низа, см" v-bind="$form.input('markBottom')" :text="!editable" />
      <div style="width: 100%">Скважина</div>
      <n-input title="диаметр, м" v-bind="$form.input('wellDiameter')" :text="!editable" inline />
      <n-input title="высота цилиндрической части, м" v-bind="$form.input('wellCylinderDiameter')" :text="!editable" inline />
      <n-input title="отметка низа по проекту, м" v-bind="$form.input('wellBottomMark')" :text="!editable" inline />
      <div style="width: 100%">Дата и время:</div>
      <n-input title="начала работ" v-bind="$form.input('startedAt')" :text="!editable" inline />
      <n-input title="окончания работ" v-bind="$form.input('endedAt')" :text="!editable" inline />
      <n-input title="Исполнитель" v-bind="$form.input('executing')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
